<template>
    <b-dropdown variant="transparent"
                dropup
                no-caret
                v-b-tooltip
                :toggle-class="buttonClass"
                title="Download">
        <template v-slot:button-content>
            <slot name="button-slot"></slot>
            <i class="fa-lg fas fa-download" v-if="!hasButtonSlot"/>
        </template>
        <b-dropdown-item v-if="!hasUnwatermarkedComp" :href="watermarkMediumUrl" target="_blank">
            Download Comp
        </b-dropdown-item>
        <b-dropdown-item v-for="version in availableVersions" :key="version" :href="versionSizedAssetDownloadUrl(version)" target="_blank">
          <span v-if="version === 'comp'">Download Unwatermarked Comp</span>
          <span v-else>Download {{humanize(version)}} Asset</span>
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
  import GeneralMixins from "../../mixins/GeneralMixins";
  import Route from "route-parser";

  export default {
    props: ['assetId', 'availableVersions', 'assetDownloadRoute', 'buttonClass', 'watermarkMediumUrl'],
    mixins: [GeneralMixins],
    computed: {
      hasButtonSlot: function () {
        return !!this.$slots['button-slot']
      },
      hasUnwatermarkedComp: function() {
        return this.availableVersions.includes('comp')
      },
    },
    methods: {
      versionSizedAssetDownloadUrl(version) {
        return new Route(this.assetDownloadRoute).reverse({
          version_size: version,
          asset_id: this.assetId
        });
      },
    },
  }
</script>